import { render, staticRenderFns } from "./carBookList.vue?vue&type=template&id=04c83a74&scoped=true&"
import script from "./carBookList.vue?vue&type=script&lang=js&"
export * from "./carBookList.vue?vue&type=script&lang=js&"
import style0 from "./carBookList.vue?vue&type=style&index=0&id=04c83a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c83a74",
  null
  
)

export default component.exports